import React, { FC, useState } from 'react';
import { NavLink } from 'react-router-dom';
import Stack from '@mui/material/Stack';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import menuItems from '../../constants/menuItems';
import styles from './navStyles';

const Navbar: FC<{}> = ({ children }) => {
  const [selectedIndex, setSelectedIndex] = useState<number>(0);
  const handleChange = (
    event: React.SyntheticEvent<Element, Event>,
    newIndex: number,
  ) => {
    setSelectedIndex(newIndex);
  };

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      margin={'0 20px'}
      sx={styles.container}
    >
      <Typography variant="h4" sx={styles.titleLogo}>
        ALEJO.
      </Typography>
      <Tabs
        textColor="primary"
        indicatorColor="primary"
        aria-label="secondary tabs example"
        value={selectedIndex}
        onChange={handleChange}
        sx={styles.selectedTab}
        TabIndicatorProps={{
          style: {
            ...styles.tabIndicator,
          },
        }}
      >
        {menuItems.map((item, index) => (
          <NavLink
            to={item.route}
            state={{ categoryId: item?.category }}
            key={item.route}
            style={({ isActive }) =>
              isActive ? styles.selectedTab : styles.navLink
            }
          >
            <Tab
              value={index}
              label={item.title}
              sx={[styles.tab, styles.hoveredText]}
            />
          </NavLink>
        ))}
      </Tabs>
      {children}
    </Stack>
  );
};

export default Navbar;
